import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Init, SetProvider } from '@store/session/session.actions';
import { SessionState } from '@store/session/session.state';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class InitGuard implements CanActivate {
  constructor(private readonly store: Store) {}

  canActivate(_: any, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (state.url.includes('provider')) {
      this.store.dispatch(new SetProvider(state.url.split('provider=')[1]));
    }

    return this.store.selectOnce(SessionState.isInitialized).pipe(
      switchMap((isInitialized) => (!isInitialized ? this.store.dispatch(new Init()) : of(undefined))),
      map(() => true)
    );
  }
}
